const whiteList = ['/login', '/401', '/404', '/import']

// 判断当前Tag是否需要缓存
export const isTags = (path) => !whiteList.includes(path)
